import type { FC } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Status } from "components/status/status";
import { Confirmation } from "sections/confirmation/confirmation";
import { NoMatch } from "../components/noMatch/noMatch";
import { useFactory } from "../helpers/reactHooks";
import { invoiceLinkRoutes } from "../sections/invoiceLink/invoiceLinkRoutes";
import { CloseView } from "../sections/obPaymentPage/components/closeView/closeView";
import { ObPaymentPageForm } from "../sections/obPaymentPage/obPaymentPageForm";
import { ObPaymentPageView } from "../sections/obPaymentPage/obPaymentPageView/obPaymentPageView";
import { paymentRoutes } from "../sections/payment/paymentRoutes";
import { paymentLinkRoutes } from "../sections/paymentLink";
import { Pp2View } from "../sections/pp2/pp2View";
import type { Config } from "../services";
import { Services } from "../services";
import { AppServices } from "./appServices";

type AppProps = { config: Config };

export const App: FC<AppProps> = ({ config }) => {
  const services = useFactory(() => new Services(config));

  return (
    <AppServices services={services}>
      <Router>
        <Routes>
          {paymentLinkRoutes}
          {paymentRoutes}
          {invoiceLinkRoutes}
          <Route path="/payment-pages/close" element={<CloseView />} />
          <Route path="/payment-pages/new" element={<ObPaymentPageForm />} />
          <Route path="/payment-pages/:id/edit" element={<ObPaymentPageForm />} />
          <Route path="/pp/:id" element={<ObPaymentPageView />} />
          <Route path="/pp2/:id" element={<Pp2View />} />
          <Route path="status/:paymentId/:state" element={<Confirmation />} />
          <Route
            path="payment/success"
            element={
              <Status type="success">
                <div>Payment successful</div>
                <div>Thank you for your business</div>
              </Status>
            }
          />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Router>
    </AppServices>
  );
};
